import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { MailWarning } from "lucide-react";

export default function Threads() {
  const navigate = useNavigate();
  const { data = [] } = useQuery({ queryKey: ["threads"], queryFn: async () => (await api.get("/threads")).data, refetchInterval: 10000 });
  return (
    <div className="animate-fade-in">
      <header className="h-14 border-b border-zinc-800 flex items-center px-6">
        <h1 className="font-heading text-lg font-semibold tracking-tight">Email Threads</h1>
        <span className="ml-3 text-xs font-mono text-zinc-500">{data.length} tracked</span>
      </header>
      <div className="p-6">
        <div className="border border-zinc-800 rounded-sm overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-zinc-950 text-[10px] uppercase tracking-wider text-zinc-500">
                <th className="text-left font-medium py-2 px-3">Ticket</th>
                <th className="text-left font-medium py-2 px-3">Subject</th>
                <th className="text-left font-medium py-2 px-3">Conversation ID</th>
                <th className="text-left font-medium py-2 px-3">Last seen</th>
              </tr>
            </thead>
            <tbody>
              {data.map((t) => (
                <tr key={t.conversation_id} onClick={() => t.ticket_id && navigate(`/tickets/${t.ticket_id}`)}
                  className="border-t border-zinc-800/60 hover:bg-zinc-900 cursor-pointer transition-colors duration-150">
                  <td className="py-2 px-3 font-mono text-blue-400">{t.ticket_id || "—"}</td>
                  <td className="py-2 px-3 text-zinc-300 max-w-[300px] truncate">{t.subject}</td>
                  <td className="py-2 px-3 font-mono text-zinc-500 text-xs truncate max-w-[200px]">{t.conversation_id}</td>
                  <td className="py-2 px-3 font-mono text-zinc-500 text-xs">{(t.last_seen || "").slice(0, 19).replace("T", " ")}</td>
                </tr>
              ))}
              {data.length === 0 && (
                <tr><td colSpan={4} className="py-16 text-center text-zinc-500">
                  <MailWarning className="h-8 w-8 mx-auto mb-3 text-zinc-700" />
                  <p className="text-sm">No email threads tracked yet.</p>
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
